<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h5 class="panel-title">
                <span class="title">Geração Automática de Declarações Em Aberto.</span>
                <br />
                <span class="navigation">Configurações > Fechamento Automático</span>
              </h5>
            </div>
          </div>
        </div>
        <TabView>
          <TabPanel header="Gerar Declarações Em Aberto" >
            <div class="card-body">
              <div class="row" v-if="existeDeclaracaoEmAndamento">
                <div class="col-md-2 col-lg-8 mb-1">
                  <Message
                    severity="warn"
                  >Existe um processo de Geração Automática de Declarações em Andamento, aguarde o término para realizar outras operações!</Message>
                </div>
              </div>
              <div class="row">
                <div class="col-md-2 col-lg-2 mb-1">
                  <label for="dataVencBoleto">Competência: *</label>
                </div>
              </div>

              <div class="row">
                <div class="col-md-2 col-lg-2 mb-3">
                  <span class="p-fluid">
                    <InputMask v-model="comp" id="comp" mask="9999/99" placeholder="Competência" />
                  </span>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div style="padding-left:15px">
                  <Button
                    class="btn btn-primary mr-2"
                    type="button"
                    icon="pi pi-search"
                    label="Consultar"
                    title="Consultar"
                    :disabled="loading || existeDeclaracaoEmAndamento"
                    @click="consultar()"
                  ></Button>
                  <Button
                    class="btn btn-primary mr-2"
                    type="button"
                    icon="pi pi-print"
                    label="Imprimir"
                    title="Imprimir"
                    :disabled="loading || existeDeclaracaoEmAndamento"
                    @click="imprimir()"
                  ></Button>
                  <Button
                    class="btn btn-primary mr-2"
                    type="button"
                    icon="pi pi-check"
                    label="Gerar"
                    title="Gerar"
                    :disabled="loading || existeDeclaracaoEmAndamento || (declaracoesList === null || declaracoesList.length === 0)"
                    @click="openGeracaoDam()"
                  ></Button>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row pr-3 pl-3">
                <DataTable :value="declaracoesList" :paginator="true" :key="0" :rows="10" :autoLayout="true" :filters="filtersTab">
                  <template #empty>Nenhum resultado encontrado.</template>

                  <Column field="tipoDescricao" header="Declaração">
                   <template #filter>
                    <InputText type="text" v-model="filtersTab['tipoDescricao']" class="p-column-filter" placeholder="Iniciando com" />
                  </template>
                  </Column>
                  <Column field="numeroDocumentoJuridico" header="CPF/CNPJ">
                   <template #filter>
                    <InputText type="text" v-model="filtersTab['numeroDocumentoJuridico']" class="p-column-filter" placeholder="Iniciando com" />
                  </template>
                  </Column>
                  <Column field="nomeGeral" header="Nome">
                   <template #filter>
                    <InputText type="text" v-model="filtersTab['nomeGeral']" class="p-column-filter" placeholder="Iniciando com" />
                  </template>
                  </Column>
                  <Column field="inscricaoMunicipal" header="Inscrição">
                   <template #filter>
                    <InputText type="text" v-model="filtersTab['inscricaoMunicipal']" class="p-column-filter" placeholder="Iniciando com" />
                  </template>
                  </Column>
                  <Column field="qtdeNotas" header="Qtde Notas não declaradas">
                   <template #filter>
                    <InputText type="text" v-model="filtersTab['qtdeNotas']" class="p-column-filter" placeholder="Iniciando com" />
                  </template>
                  </Column>
                  <Column
                    field="qtdeNotasIncideIss"
                    header="Qtde Notas não declaradas (Incide ISS)"
                  >
                   <template #filter>
                    <InputText type="text" v-model="filtersTab['qtdeNotasIncideIss']" class="p-column-filter" placeholder="Iniciando com" />
                  </template>
                  </Column>
                  <Column
                    field="valorIssFormatado"
                    header="Total ISS"
                    bodyStyle="text-align:center"
                  >
                   <template #filter>
                    <InputText type="text" v-model="filtersTab['valorIssFormatado']" class="p-column-filter" placeholder="Iniciando com" />
                  </template>
                  </Column>
                </DataTable>
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Declarações geradas" >

          <div class="card-body">
            <div class="row pr-3 pl-3">
              <DataTable
                :value="declaracoesGeradasList"
                :paginator="true"
                :rows="10"
                :key="1"
                :autoLayout="true"
                :filters="filters"
              >
                <template #empty>Nenhum resultado encontrado.</template>

                <Column headerStyle="width: 1%">
                  <template #body="slotProps">
                    <div class="dropdown">
                      <Button
                        class="btn btn-primary"
                        type="button"
                        id="dropdownMenuButton"
                        icon="pi pi-angle-down"
                        data-toggle="dropdown"
                        title="Opções"
                        aria-haspopup="true"
                        aria-expanded="false"
                      ></Button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <button
                          class="dropdown-item"
                          type="button"
                          :disabled="loading || existeDeclaracaoEmAndamento"
                          @click="impressaoDeclaracao(slotProps.data.id)"
                        >
                          <span class="pi pi-print mr-2"></span>Impressão
                        </button>
                        <button
                          class="dropdown-item"
                          type="button"
                          :disabled="loading || existeDeclaracaoEmAndamento"
                          @click="reprocessarDeclaracao(slotProps.data.id)"
                        >
                          <span class="pi pi-refresh mr-2"></span>Reprocessar DAMs com erro
                        </button>
                      </div>
                    </div>
                  </template>
                </Column>
                <Column field="ano" header="Ano" filterMatchMode="startsWith">
                  <template #filter>
                    <InputText type="text" v-model="filters['ano']" class="p-column-filter" placeholder="Iniciando com" />
                  </template>
                </Column>
                <Column field="mes" header="Mês">
                  <template #filter>
                    <InputText type="text" v-model="filters['mes']" class="p-column-filter" placeholder="Iniciando com" />
                  </template>
                </Column>
                <Column field="dataInicioFormatada" header="Data Início">
                  <template #filter>
                    <InputText type="text" v-model="filters['dataInicioFormatada']" class="p-column-filter" placeholder="Iniciando com" />
                  </template>
                </Column>
                <Column field="dataFimFormatada" header="Data Término">
                  <template #filter>
                    <InputText type="text" v-model="filters['dataFimFormatada']" class="p-column-filter" placeholder="Iniciando com" />
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>
          </TabPanel>
        </TabView>
      </div>
    </div>
    <Dialog
      header="Gerar Declarações(s)"
      :visible.sync="displayVencGeracao"
      :style="{width: '30vw'}"
      :modal="true"
    >
      <div class="col-md-8 mb-8">
        <label>Confirma a Geração das Declarações para competência selecionada?</label>
      </div>
      <hr/>
      <div class="botoes-avancar-voltar">
        <Button label="Sim" icon="pi pi-check" @click="gerar()" :disabled="loading" />
        <Button
          label="Não"
          icon="pi pi-times"
          @click="hideVencGeracao()"
          class="p-button-secondary"
        />
      </div>
    </Dialog>
  </div>
</template>
<script>
import LoginService from "../services/acesso/login.service";
import GeracaoAutomaticaService from "../services/nfse/geracao.automatica.service";
import ReportService from "../services/report.service";

export default {
  name: "geracaoAutomatica",
  data() {
    return {
      loading: false,
      filtersTab: {},
      filters: {},
      comp: null,
      vencimento: null,
      displayVencGeracao: false,
      declaracoesList: [],
      declaracoesGeradasList: [],
      declaracoesAtivasList: [],
      existeDeclaracaoEmAndamento: false
    };
  },
  created() {
    this.currentUser = LoginService.currentUserValue;
    this.processando(true);
    GeracaoAutomaticaService.findAllDeclaracoes(
      this.currentUser.usuario.idCliente
    )
      .then(response => {
        console.log(this.declaracoesGeradasList);
        this.declaracoesGeradasList = response.data;
      })
      .then(() => {
        this.processando(false);
      });
    this.processando(true);
    GeracaoAutomaticaService.findAllDeclaracoesEmAndamento(
      this.currentUser.usuario.idCliente
    )
      .then(response => {
        this.declaracoesAtivasList = response.data;
        this.existeDeclaracaoEmAndamento = this.declaracoesAtivasList.length > 0;
        console.log(this.existeDeclaracaoEmAndamento);
      })
      .then(() => {
        this.processando(false);
      });
  },
  methods: {
    consultar() {
      this.processando(true);
      if (this.comp) {
        var array = this.comp.split("/");
        let ano = array[0];
        let mes = array[1];
        GeracaoAutomaticaService.findAll(
          this.currentUser.usuario.idCliente,
          ano,
          mes
        )
          .then(response => {
            this.declaracoesList = response.data;
          })
          .then(() => {
            this.processando(false);
          });
      } else {
        this.$root.$emit("alert:warn", "Informe uma competência válida!");
        this.processando(false);
      }
    },
    openGeracaoDam() {
      this.processando(true);
      if (!this.comp) {
        this.$root.$emit("alert:warn", "Informe uma competência válida!");
        this.processando(false);
      } else {
        this.processando(false);
        this.displayVencGeracao = true;
      }
    },
    hideVencGeracao() {
      this.displayVencGeracao = false;
    },
    gerar() {
      this.processando(true);
      var array = this.comp.split("/");
      let ano = array[0];
      let mes = array[1];
      GeracaoAutomaticaService.gerarDeclaracoes(
        this.currentUser.usuario.idCliente,
        this.currentUser.usuario.idUsuario,
        ano,
        mes,
        this.declaracoesList
      )
        .then(response => {
          this.existeDeclaracaoEmAndamento = true;
          this.$root.$emit("alert:info", response.data);
        })
        .then(() => {
          this.processando(false);
          this.displayVencGeracao = false;
        });
    },
    imprimir() {
      var msg = null;
      if (!this.comp) {
        msg = "É necessário informar a competência!";
      }
      if (!msg) {
        this.processando(true);
        var array = this.comp.split("/");
        let ano = array[0];
        let mes = array[1];
        ReportService.imprimir("ConsultaGeracaoAutomatica", [
          {
            param: "ID_CLIENTE",
            string: this.currentUser.usuario.idCliente
          },
          {
            param: "ANO",
            string: ano
          },
          {
            param: "MES",
            string: mes
          }
        ])
          .then(
            () => {},
            error => {
              this.$root.$emit("alert:warn", "Erro ao Imprimir!");
              console.log(error);
            }
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        this.$root.$emit("alert:warn", msg);
      }
    },
    impressaoDeclaracao(id){
        ReportService.imprimir("ConsultaGeracaoAutomaticaProcessada", [
          {
            param: "ID_CLIENTE",
            string: this.currentUser.usuario.idCliente
          },
          {
            param: "ID",
            string: id
          }
        ])
          .then(
            () => {},
            error => {
              this.$root.$emit("alert:warn", "Erro ao Imprimir!");
              console.log(error);
            }
          )
          .then(() => {
            this.processando(false);
          });
    },
    reprocessarDeclaracao(id){
      GeracaoAutomaticaService.reprocessarDeclaracoes(
        this.currentUser.usuario.idCliente,
        this.currentUser.usuario.idUsuario,
        id
      )
        .then(response => {
          this.existeDeclaracaoEmAndamento = true;
          this.$root.$emit("alert:info", response.data);
        })
        .then(() => {
          this.processando(false);
          this.displayVencGeracao = false;
        });
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    }
  }
};
</script>

<style scoped>
</style>